const verifyAttributeExistenceToString = (object, attribute, addToEndLabel) => {

    let endResult = ''

    if (Array.isArray(attribute)) {
        for (let i = 0; i < attribute.length; i++) {
            if (object?.[attribute[i]]) {
                let value = object[attribute[i]];
                if (attribute[i].toLowerCase() === "region") {
                    value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
                }
                endResult += `${value}${i === attribute.length - 1 ? '' : ', '}`;
            }
        }
        if(endResult === '') return "TBD";
        return endResult;
    } else {
        if (object?.[attribute]) {
            endResult = object[attribute];

            if (addToEndLabel) endResult = endResult + ' ' + addToEndLabel
        }
    }
    if(endResult === '') return "TBD";
    return endResult;
}

export default verifyAttributeExistenceToString;
